"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextListOptionMenuOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const TextListOptionMenuOverview_style_1 = require("./TextListOptionMenuOverview.style");
const BulletOption_1 = require("./components/BulletOption");
const OrderedOption_1 = require("./components/OrderedOption");
const OrderedListContext_1 = require("../OrderedListMenu/OrderedListContext");
function TextListOptionMenuOverview({ variant = 'bullet-list', minLevel, maxLevel, defaultOptions, symbols, defaultRegex, regexOptions, selectedValues, acrossPages = false, labels, continueAcrossPagesEditable = true, onCancel, onSave, }) {
    const [values, setValues] = (0, react_1.useState)(selectedValues);
    const [options, setOptions] = (0, react_1.useState)(defaultOptions);
    const [level, setLevel] = (0, react_1.useState)(selectedValues.length);
    const [regex, setRegex] = (0, react_1.useState)(defaultRegex !== null && defaultRegex !== void 0 ? defaultRegex : Array(level).fill(''));
    const [isAcrossPages, setIsAcrossPages] = (0, react_1.useState)(acrossPages);
    const mapOptions = (index, item) => {
        const mappedOptions = options[index].map((option) => {
            const hasBadge = option === null || option === void 0 ? void 0 : option.badge;
            return Object.assign(Object.assign({}, option), { isSelected: option.value === item, badge: hasBadge
                    ? {
                        icon: {
                            size: 'XSmall',
                            name: 'cross',
                            color: ui_common_components_1.Theme.Color.Feedback.Alert,
                        },
                        onClick: () => onRemoveOption({
                            value: option.value,
                            label: option.label,
                        }, index),
                    }
                    : null });
        });
        return mappedOptions;
    };
    const onSelect = (newValue, level) => {
        setValues(values.map((value, index) => {
            if (index === level) {
                return newValue;
            }
            else {
                return value;
            }
        }));
    };
    const onCheckAcrossPages = (checked) => {
        setIsAcrossPages(checked);
    };
    const onAddLevel = () => {
        setLevel(level + 1);
        const newOptions = variant === 'bullet-list'
            ? defaultOptions[0].slice(0, 5)
            : defaultOptions[0];
        setOptions([...options, newOptions]);
        setValues([...values, defaultOptions[0][0].value]);
        setRegex([...regex, '']);
    };
    const onRemoveLevel = (removedLevel) => {
        setLevel(level - 1);
        setOptions(options.filter((value, index) => index !== removedLevel - 1));
        setValues(values.filter((value, index) => index !== removedLevel - 1));
        setRegex(regex.filter((value, index) => index !== removedLevel - 1));
    };
    const onAddOption = (symbol, currentIndex) => {
        const newOption = {
            value: symbol.value,
            label: symbol.label,
            isSelected: false,
            badge: {
                icon: {
                    size: 'XSmall',
                    name: 'cross',
                    color: ui_common_components_1.Theme.Color.Feedback.Alert,
                },
                onClick: () => onRemoveOption(symbol, currentIndex),
            },
        };
        const updatedOptions = [...options.map((row) => [...row])];
        const updatedValues = values.map((value) => value);
        updatedOptions[currentIndex].push(newOption);
        updatedValues[currentIndex] = newOption.value;
        setOptions(updatedOptions);
        setValues(updatedValues);
    };
    const onRemoveOption = (symbol, currentIndex) => {
        setOptions((options) => {
            const updatedOptions = [...options.map((row) => [...row])];
            updatedOptions[currentIndex].pop();
            return updatedOptions;
        });
        setValues((values) => {
            const selected = values.find((value) => value === symbol.value);
            if (!selected)
                return values;
            return values.map((value, index) => {
                if (index === currentIndex) {
                    return options[currentIndex][0].value;
                }
                else {
                    return value;
                }
            });
        });
    };
    const onRegexChange = (currentRegex, selectedIndex) => {
        const updatedRegex = regex.map((value, index) => index === selectedIndex ? currentRegex : value);
        setRegex(updatedRegex);
    };
    return ((0, jsx_runtime_1.jsxs)(TextListOptionMenuOverview_style_1.StyledContainer, { variant: variant, children: [(0, jsx_runtime_1.jsx)(TextListOptionMenuOverview_style_1.StyledOptionGroupsWrapper, { variant: variant, children: values.map((item, index) => {
                    return variant === 'bullet-list' ? ((0, jsx_runtime_1.jsx)(BulletOption_1.BulletOption, { index: index, minLevel: minLevel, options: mapOptions(index, item), symbols: symbols, labels: labels, onSelect: onSelect, onRemoveLevel: onRemoveLevel, onAddOption: (symbol) => onAddOption(symbol, index) }, `option-wrapper-${item}-${index}`)) : ((0, jsx_runtime_1.jsx)(OrderedOption_1.OrderedOption, { index: index, minLevel: minLevel, listStyleOptions: mapOptions(index, item), defaultRegex: regex[index], regexOptions: regexOptions, labels: labels, onRegexChange: onRegexChange, onSelect: onSelect, onRemoveLevel: onRemoveLevel }, `option-wrapper-${item}-${index}`));
                }) }), (0, jsx_runtime_1.jsx)(TextListOptionMenuFooter, { disabledAddLevel: level >= maxLevel, variant: variant, isAcrossPages: isAcrossPages, onAddLevel: onAddLevel, labels: labels, continueAcrossPagesEditable: continueAcrossPagesEditable, onSave: () => onSave(values, { acrossPages: isAcrossPages, regex }), onCancel: onCancel, onCheckAcrossPages: onCheckAcrossPages })] }));
}
exports.TextListOptionMenuOverview = TextListOptionMenuOverview;
function TextListOptionMenuFooter({ variant, isAcrossPages, disabledAddLevel, labels, continueAcrossPagesEditable, onAddLevel, onSave, onCancel, onCheckAcrossPages, }) {
    const { onActiveTabChange } = (0, react_1.useContext)(OrderedListContext_1.OrderedListContext);
    const onSaveHandler = () => {
        onActiveTabChange === null || onActiveTabChange === void 0 ? void 0 : onActiveTabChange(0);
        onSave();
    };
    return ((0, jsx_runtime_1.jsxs)(TextListOptionMenuOverview_style_1.StyledButtonsWrapper, { children: [(0, jsx_runtime_1.jsx)(TextListOptionMenuOverview_style_1.StyledAddNewLevelButtonWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "secondary", onClick: onAddLevel, label: labels.addLevel, disabled: disabledAddLevel }) }), variant === 'ordered-list' ? ((0, jsx_runtime_1.jsxs)(TextListOptionMenuOverview_style_1.StyledCheckBoxAndTextWrapper, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'Small', children: labels.continueAcrossPages }), (0, jsx_runtime_1.jsx)(TextListOptionMenuOverview_style_1.StyledCheckBoxWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Checkbox, { checked: isAcrossPages, disabled: !continueAcrossPagesEditable, onClick: onCheckAcrossPages }) })] })) : null, (0, jsx_runtime_1.jsxs)(TextListOptionMenuOverview_style_1.StyledRowButtonsWrapper, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "ghost", onClick: onCancel, label: labels.cancel }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "primary", onClick: onSaveHandler, label: labels.save })] })] }));
}
//# sourceMappingURL=TextListOptionMenuOverview.js.map